module.exports = __webpack_public_path__ + "static/media/story-linkedin.aa330f6f.png";